<template>
    <Modal
        v-if="dialog"
        :dialog.sync="dialog"
        :title="reportName"
        contentClass="esh-theme adminModal"
        :width="420"
    >
        <template #body>
            <v-card outlined class="infoBody">
                <v-row no-gutters>
                    <v-col>
                        <v-form>
                            <template v-if="reportHasDates">
                                <v-col md="6">
                                    <DatePicker
                                        :labelText="'от'"
                                        :dateValue.sync="options.start_at"
                                        v-model="options.start_at"
                                        dense
                                    />
                                </v-col>
                                <v-col md="6">
                                    <DatePicker
                                        :labelText="'до'"
                                        :dateValue.sync="options.end_at"
                                        v-model="options.end_at"
                                        dense
                                    />
                                </v-col>
                            </template>
                            <template v-if="reportHasParentUnit">
                                <Select
                                    v-model="options.parent_unit"
                                    :items="municipalities"
                                    item-text="short_name"
                                    item-value="id"
                                    label="Выберите район"
                                    @change="changeDistrict($event)"
                                />
                                <Select
                                    v-model="options.unit"
                                    :items="schools"
                                    item-text="short_name"
                                    item-value="id"
                                    label="Выберите школу"
                                />
                            </template>
                            <template v-if="reportHasUnit">
                                <Select
                                    v-model="options.unit"
                                    :items="schools"
                                    item-text="short_name"
                                    item-value="id"
                                    label="Выберите школу"
                                />
                            </template>
                            <template v-if="reportHasCardEventSuccessPassages">
                                <Select
                                        v-model="options.event"
                                        :items="successPassageEvents"
                                        item-text="name"
                                        item-value="id"
                                        label="Тип прохода"
                                        class="fs-admin-complex-autocomplete"
                                />
                            </template>
                            <template v-if="reportHasCardEventDeniedPassages">
                                <Select
                                        v-model="options.event"
                                        :items="deniedPassageEvents"
                                        item-text="name"
                                        item-value="id"
                                        label="Тип прохода"
                                        class="fs-admin-complex-autocomplete"
                                />
                            </template>
                            <template v-if="reportHasCardType">
                                <Select
                                        v-model="options.card_type"
                                        :items="cardTypes"
                                        item-text="name"
                                        item-value="id"
                                        label="Тип карты"
                                        class="fs-admin-complex-autocomplete"
                                />
                            </template>
                            <template v-if="reportHasCardStatus">
                                <Select
                                        v-model="options.card_status"
                                        :items="cardStatuses"
                                        item-text="name"
                                        item-value="id"
                                        label="Статус карты"
                                        class="fs-admin-complex-autocomplete"
                                />
                            </template>
                            <template v-if="reportHasPresence">
                                <Select
                                        v-model="options.presence_type"
                                        :items="presenceTypes"
                                        item-text="name"
                                        item-value="id"
                                        label="Тип"
                                        class="fs-admin-complex-autocomplete"
                                />
                                <v-col md="6">
                                    <DatePicker
                                            :labelText="'Дата'"
                                            :dateValue.sync="options.presence_date"
                                            v-model="options.presence_date"
                                            dense
                                    />
                                </v-col>
                                <v-col md="6">
                                    <TimePicker
                                            :labelText="'Время'"
                                            :timeValue.sync="options.presence_time"
                                            v-model="options.presence_time"
                                            dense
                                    />
                                </v-col>
                            </template>
                        </v-form>
                    </v-col>
                </v-row>
            </v-card>
        </template>
        <template #actions>
            <v-row align="center" justify="end" no-gutters>
                <v-btn
                    :disabled="!valid"
                    @click="onRequest"
                >
                    <v-icon left>done_all</v-icon> Создать
                </v-btn>
            </v-row>
        </template>
    </Modal>
</template>

<script>
  import { mapState } from 'vuex'
  import {DatePicker, Modal, Select, TimePicker} from '@/components/common'
  import moment from 'moment'

  import {REPORT_TYPES} from "@/views/common/ReportsView";
  import format from "@/config/format";

  const DEFAULT_OPTIONS = {
    start_at: null,
    end_at: null,
    parent_unit: null,
    unit: null,
    event: null,
    card_type: null,
    card_status: null,
    presence_type: null,
    presence_date: null,
    presence_time: null,
  }

  export default {
    name: 'RequestReportModalView',
    components: {
      Modal,
      DatePicker,
      Select,
      TimePicker,
    },
    props: {
      show: {
        props: Boolean,
        default: false
      },
      reportName: {
        props: String
      },
      reportType: {
        props: Array
      },
      suggestionsParentUnit: {
        props: Function
      },
      suggestionsUnit: {
        props: Function
      },
      requestReport: {
        props: String
      },
      childId: {
        props: Number
      }
    },
    data() {
      return {
        options: {...DEFAULT_OPTIONS},
        municipalities: [],
        schools: [],
        rules: {
          required: value => !!value || 'Заполните обязательно!',
        }
      }
    },
    computed: {
      ...mapState({
        timezone: state => state.common.user.timezone,
        successPassageEvents: state => {
          return state.common.constants.card_events.success_passage.map(evId =>
            state.common.constants.card_events.value.find(e => e.id === evId)
          )
        },
        deniedPassageEvents: state => {
          return state.common.constants.card_events.denied_passage.map(evId =>
            state.common.constants.card_events.value.find(e => e.id === evId)
          )
        },
        cardTypes: state => state.common.constants.card_types,
        presenceTypes: state => state.common.constants.presence_types,
        cardStatuses: state => state.common.constants.card_statuses,
      }),
      dialog: {
        get() {
          return this.show
        },
        set(value) {
          this.$emit('update:show', value)
        }
      },
      reportHasDates() {
        const types = this.reportType
        return types.includes(REPORT_TYPES.withDates)
      },
      reportHasParentUnit() {
        const types = this.reportType
        return types.includes(REPORT_TYPES.withParentUnit)
      },
      reportHasUnit() {
        const types = this.reportType
        return types.includes(REPORT_TYPES.withUnit)
      },
      reportHasCardEventSuccessPassages() {
        const types = this.reportType
        return types.includes(REPORT_TYPES.withCardEventSuccessPassages)
      },
      reportHasCardEventDeniedPassages() {
        const types = this.reportType
        return types.includes(REPORT_TYPES.withCardEventDeniedPassages)
      },
      reportHasCardType() {
        const types = this.reportType
        return types.includes(REPORT_TYPES.withCardTypes)
      },
      reportHasCardStatus() {
        const types = this.reportType
        return types.includes(REPORT_TYPES.withCardStatuses)
      },
      reportHasPresence() {
        const types = this.reportType
        return types.includes(REPORT_TYPES.withPresence)
      },
      valid() {
        let datesValid = true
        let presenceValid = true
        if (this.reportHasDates) {
          datesValid = this.options.start_at && this.options.end_at
        }
        if (this.reportHasPresence) {
          presenceValid = !!this.options.presence_time && !!this.options.presence_date
        }
        return datesValid && presenceValid
      }
    },
    watch: {
      show: function(state) {
        if (state) {
          this.schools = []
          this.municipalities = []
          this.options = {...DEFAULT_OPTIONS}
          if (this.reportHasParentUnit) {
            this.loadMunicipalities()
          }
          if (this.reportHasUnit) {
            this.loadDistrictSchools()
          }
        }
      }
    },
    methods: {
      async onRequest() {
        const params = {
          timezone: this.timezone,
        }
        if (this.options.start_at) {
          params.start_at = this.options.start_at
        }
        if (this.options.end_at) {
          params.end_at = this.options.end_at
        }
        if (this.options.parent_unit) {
          params.parent_unit = this.options.parent_unit
        }
        if (this.options.unit) {
          params.unit = this.options.unit
        }
        if (this.childId) {
          params.childId = this.childId
        }
        if (this.options.event) {
          params.event = this.options.event
        }
        if (this.options.card_type) {
          params.card_type = this.options.card_type
        }
        if (this.options.card_status) {
          params.card_status = this.options.card_status
        }
        if (this.options.presence_type) {
          params.presence_type = this.options.presence_type
        }
        if (this.options.presence_time && this.options.presence_date) {
          const time = this.options.presence_date + ' ' + this.options.presence_time
          const utcTime = moment(time, format.datepickerDateTime).utc()
          params.presence_time = utcTime.format('YYYY-MM-DD HH:mm:ss')
        }
        try {
          await this.requestReport(params)
          this.$emit('update:dialog', false)
          this.$emit('report:request')
          this.dialog = false
        } catch (error) {
          this.$notify({
            type: 'error',
            text: 'Не удалось запросить отчет'
          })
        }
      },
      changeDistrict(districtId) {
        this.schools = []

        if (districtId !== null) {
          this.loadDistrictSchools(districtId)
        }
      },
      async loadDistrictSchools(municipalityId) {
        try {
          const { data: { results } } = await this.suggestionsUnit({
            district: municipalityId
          })

          this.schools = results
        } catch (error) {
          this.$notify({
            type: 'error',
            text: 'Не удалось получить список школ муниципалитета'
          })
        }
      },
      async loadMunicipalities() {
        try {
          const { data: { results } } = await this.suggestionsParentUnit()
          this.municipalities = results
        } catch (error) {
          console.log(error)
          this.$notify({
            type: 'error',
            text: 'Не удалось получить список муниципалитетов'
          })
        }
      }
    }
  }
</script>
